import styled from 'styled-components';

export const AddLiabilitiesContainer = styled.div`
    border: ${({ theme }) => `1px solid ${theme.Colors.Aliases.textLightSecondary}`};
    padding: ${({ theme }) => `${theme.Spacing.spacing3x}`};
`;
